import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage = 'Hola, me interesa la propuesta de lanzamiento Atache (Vital Pharma) y TNO Network con Expedientes del Delito - Belleza con Evidencia.';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
      >
        ¿Listo para lanzar Atache en Venezuela?
      </Box>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}
      >
        Atache y TNO Network: Belleza con Evidencia para la mujer que decide con inteligencia.
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          component="img"
          src="https://files.tnonetwork.com/users/talent/angelicalugo2.jpeg"
          alt="Angélica Lugo - Expedientes del Delito | TNO Network"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            boxShadow: 3,
            objectFit: 'cover',
            mb: 4,
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          gap={2}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
              window.open(url, '_blank');
            }}
          >
            Contactar para propuesta Atache
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Atache & Expedientes del Delito | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
